import React from 'react';
import imgResolver from '../utils/img-resolver';

import LoadingView from '../components/LoadingView';
import checkOverflow from "../utils/checkModalOverflow";


class SendHiresListModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && Object.keys(nextProps.data).length) {
            this.setState({data: nextProps.data});
        }

        if (this.props.isActive !== nextProps.isActive) {
            checkOverflow(nextProps.isActive);
        }
    }

    render() {
        let classes = "modal-overlay send-hires-list-modal-overlay " + (this.props.isActive ? "active" : "");
        let content;
        if (this.state.data && Object.keys(this.state.data).length) {
            content = this.renderSuccess();
        } else {
            content = this.loading();
        }

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                {content}
            </div>
        );
    }

    loading() {
        return(
            <div className="modal whitebox" onClick={this.modalClick.bind(this)}>
                <header className="modal-header">
                    <h1>Send hires list</h1>
                    <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                </header>
                <div className="modal-content">
                    <div className="hires-modal-loading">
                        <LoadingView />
                    </div>
                </div>
            </div>
        );
    }

    renderSuccess() {
        let successEmailsText;
        let failedEmailsText;
        if (this.props.data !== null) {
            if (this.props.data.success_emails && this.props.data.success_emails.length) {
                const successEmails = this.props.data.success_emails.join(', ');
                successEmailsText = `Email has been sent to : ${successEmails}`;
            }
            if (this.props.data.success_emails && this.props.data.failed_emails.length) {
                const failedEmails = this.props.data.failed_emails.join(', ');
                failedEmailsText = `Email has been sent to : ${failedEmails}`;
            }
        }
        return(
            <div className="modal whitebox" onClick={this.modalClick}>
                <header className="modal-header">
                    <h1>Send hires list</h1>
                    <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                </header>
                <div className="modal-content modal-content-sent">
                    <div className="sent-msg">
                        <img className="modal-sent-img" src={require('../styles/images/icon_update_sent.svg')} alt="" />
                        <p>{successEmailsText}</p>
                        <p>{failedEmailsText}</p>
                    </div>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.props.toggleModal();
    }
}

export default SendHiresListModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/SendHiresListModal.js
 **/